module.exports = __webpack_public_path__ + "static/img/logo.c5af0a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo.png
// module id = dLd/
// module chunks = 1